import Vue from 'vue';

import * as echarts from 'echarts/core';
import {
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    GaugeChart
} from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    ToolboxComponent,
    LegendComponent,
    GridComponent
} from 'echarts/components';
import {
    CanvasRenderer
} from 'echarts/renderers';

echarts.use(
    [
        BarChart, 
        PieChart,
        LineChart,
        RadarChart,
        
        GaugeChart,

        TitleComponent, 
        TooltipComponent, 
        ToolboxComponent,
        GridComponent, 
        CanvasRenderer, 
        LegendComponent
    ]
);

const _echarts = {
    install: (Vue,options) => {
        Vue.prototype.$echarts = echarts;
    }
}

export default _echarts;